var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M472.307 3.257L245.192 230.393 18.077 3.257C13.84-.836 7.087-.718 2.994 3.519c-3.992 4.134-3.992 10.687 0 14.82l234.668 234.666c4.165 4.164 10.917 4.164 15.083 0L487.412 18.339c4.237-4.093 4.354-10.845.262-15.083-4.093-4.237-10.845-4.354-15.083-.262a10.787 10.787 0 00-.262.262h-.02z"}));
}

ArrowDown.defaultProps = {"viewBox":"0 0 490.668 256.128","width":"490.668","height":"256.128"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
